// extracted by mini-css-extract-plugin
export default {"classType":"ClassType_classType__hpKtI","active":"ClassType_active__n7VxC"};